/**
 * @generated SignedSource<<19670538d8bdbbd810dbeeae1fa1f181>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MenuMarkAllAsReadMutation$variables = {};
export type MenuMarkAllAsReadMutation$data = {
  readonly feedbackMarkAllAsRead: {
    readonly updatedCount: number;
  } | null;
};
export type MenuMarkAllAsReadMutation = {
  response: MenuMarkAllAsReadMutation$data;
  variables: MenuMarkAllAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeedbackMarkAllAsRead",
    "kind": "LinkedField",
    "name": "feedbackMarkAllAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MenuMarkAllAsReadMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MenuMarkAllAsReadMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e5db695e315162865112503f1ffb97a8",
    "id": null,
    "metadata": {},
    "name": "MenuMarkAllAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation MenuMarkAllAsReadMutation {\n  feedbackMarkAllAsRead {\n    updatedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5f34e4fba63cc07841f5529f4499189";

export default node;
